import React from "react";
import { useParams } from "react-router-dom";
import ourTeamData from "../../data/our-team.json";

export default function TeamMember() {
  const { id } = useParams();
  const member = ourTeamData.members.find((m) => m.id === parseInt(id));

  if (!member) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">Team member not found</div>
      </div>
    );
  }

  const memberImage = require(`../../images/our-team/${member.image}`);

  return (
    <>
      <section className="team-single-section ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-sm-12 col-lg-5">
              <div className="team-single-img">
                <img
                  src={memberImage}
                  alt={member.name}
                  className="img-fluid rounded shadow-sm"
                />
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-lg-6">
              <div className="team-single-text">
                <div className="team-name mb-4">
                  <h4 className="mb-1">{member.name}</h4>
                  <span>{member.role}</span>
                </div>

                <div className="text-content mt-20">
                  {member.descriptions.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>

                <ul className="team-single-info">
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href={`mailto:${member.email}`} className="text-decoration-none">
                      {member.email}
                    </a>
                  </li>
                  <li className="mt-3">
                    <strong>Connect:</strong>
                    <div className="list-inline team-social social-icon mt-2">
                      {member.socials.linkedin && (
                        <a 
                          href={member.socials.linkedin} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-linkedin"></span>
                        </a>
                      )}
                      {member.socials.facebook !== "#/" && (
                        <a 
                          href={member.socials.facebook}
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-facebook"></span>
                        </a>
                      )}
                      {member.socials.twitter !== "#/" && (
                        <a 
                          href={member.socials.twitter}
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-twitter"></span>
                        </a>
                      )}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
